//
//
//
//
//
//
//
//
//

export default {
    props: {
        file: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            iconObj: {
                'docx': {
                    icon: 'icon-bhtfileword',
                    color: '#2B5797'
                },
                'doc': {
                    icon: 'icon-bhtfileword',
                    color: '#2B5797'
                },

                'zip': {
                    icon: 'icon-bhtzip',
                    color: '#34A4F0'
                },
                'rar': {
                    icon: 'icon-bhtRAR',
                    color: '#34A4F0'
                },

                'jpg': {
                    icon: 'icon-bhtfile-jpg',
                    color: '#34A4F0'
                },
                'jpeg': {
                    icon: 'icon-bhtfile-jpg',
                    color: '#34A4F0'
                },
                'png': {
                    icon: 'icon-bhtPNG',
                    color: '#34A4F0'
                }
            }
        }
    },
    computed: {
        fileType(){
            if(!this.file.fileUrl) return
            return this.file.fileUrl.slice(this.file.fileUrl.lastIndexOf('.') + 1)

        },
        
        iconClass() {
            var mapObj = this.iconObj[this.fileType] || {};
            return mapObj.icon;
        },
        iconStyle() {
            var mapObj = this.iconObj[this.fileType] || {};
            return {
                color: mapObj.color
            }
        }
    },
    watch: {

    },
    methods: {
        download() {
            if(!this.file.fileUrl) return;
            downloader(this.file.fileUrl);
        },
    },
    created: function() {

    },
    mounted: function() {

    }
}
